import React, { useContext } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';

import ProfileSubscriptionList from './ProfileSubscriptionList';
import Head from 'components/common/Head';

import ProfileContext from 'contexts/ProfileContext';

import useInfiniteQuerySubscriptions from 'hooks/useInfiniteQuerySubscriptions';
import useUtilFilters from 'hooks/useUtilFilters';

const ProfileSubscriptionListPage = () => {
  const { employee } = useContext(ProfileContext);
  const location = useLocation();
  const handleError = useErrorHandler();
  const { status } = queryString.parse(location.search);
  const { applyFilters } = useUtilFilters({ status });

  const {
    data: subscriptions_data,
    is_loading: is_subscriptions_loading,
    has_next_page,
    fetchNextPage,
  } = useInfiniteQuerySubscriptions({
    status,
    onError: (error: $TSFixMe) => handleError(error),
  });

  const subscriptions = is_subscriptions_loading
    ? []
    : // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      subscriptions_data.pages.map(({ subscriptions }) => subscriptions).flat();

  return (
    <>
      <Head title={'My Subscriptions'} />
      <ProfileSubscriptionList
        subscriptions={subscriptions}
        is_subscriptions_loading={is_subscriptions_loading}
        has_more_subscriptions={has_next_page}
        onNextPage={() => fetchNextPage()}
        employee={employee}
        status={status}
        applyFilters={applyFilters}
      />
    </>
  );
};

export default ProfileSubscriptionListPage;
